"use strict";

exports.__esModule = true;
exports.FlexColumnWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _FlexColumnElement = require("./FlexColumnElement");
var _FlexColumnFields = require("./FlexColumnFields");
var _FlexColumnHeader = require("./FlexColumnHeader");
var _FlexColumnThumbnail = require("./FlexColumnThumbnail");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var FlexColumnWidget = exports.FlexColumnWidget = {
  name: "FlexColumn",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "FlexColumnWidget.label",
    defaultMessage: "Column"
  }),
  icon: "one-column",
  createElement: function createElement(props) {
    return {
      type: "FlexColumn",
      props: Object.assign({
        width: 128,
        height: 256
      }, props),
      children: []
    };
  },
  showInPalette: false,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["gutter", "backgroundColor", "backgroundColorSource"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: ["x", "y", "width", "height"],
  propConstraints: {
    width: {
      "default": 128,
      min: 32,
      max: 3840
    },
    height: {
      "default": 256,
      min: 32,
      max: 2160
    }
  },
  components: {
    Header: _FlexColumnHeader.FlexColumnHeader,
    Element: _FlexColumnElement.FlexColumnElement,
    Fields: _FlexColumnFields.FlexColumnFields,
    Thumbnail: _FlexColumnThumbnail.FlexColumnThumbnail
  }
};